var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('AllRecordsTable',{attrs:{"submit-button-text":_vm.currentTable.buttonText,"table-name":_vm.tableName,"link-slug":_vm.tableName,"image-subfolder":_vm.imageSubfolder,"title":_vm.currentTable.title,"columns":_vm.getColumns(),"order-fields":_vm.getOrderFields(),"rows":_vm.getRows(),"filter-fields":_vm.getFilterFields()}})}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5e7e4825","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/stock/pages/StockEntityRecordsPage.vue
// module id = null
// module chunks = 